import { Owner } from '../owner';

export const ownerNormalizer = (owner: Owner) => {
  return {
    label: owner?.name ?? '',
    value: owner?.ownerId ?? '',
  };
};
